// Helpers
export const classNames = (...arr) => arr.filter(Boolean).join(' ');

// Formatters
const currencyFmt = new Intl.NumberFormat('en-GH', { style: 'currency', currency: 'GHS', minimumFractionDigits: 2 });
export const formatCedi = (n) => currencyFmt.format(Number(n || 0));
export const formatDateTime = (ts) => { try { return new Date(ts).toLocaleString(); } catch { return ts || ''; } };
export const formatDate = (ts) => { try { return new Date(ts).toLocaleDateString(); } catch { return ts || ''; } };
export const relativeTimeFrom = (ts) => {
  if (!ts) return '';
  const diffMs = Date.now() - new Date(ts).getTime();
  const past = diffMs >= 0;
  const m = Math.floor(Math.abs(diffMs) / 60000);
  if (m < 1) return past ? 'just now' : 'in <1m';
  if (m < 60) return past ? `${m}m ago` : `in ${m}m`;
  const h = Math.floor(m / 60);
  if (h < 24) return past ? `${h}h ago` : `in ${h}h`;
  const d = Math.floor(h / 24);
  return past ? `${d}d ago` : `in ${d}d`;
};

// Diff helpers
const itemsToMap = (items) => {
  const map = new Map();
  (items || []).forEach(i => map.set(i.name, { ...i }));
  return map;
};

export const diffItems = (original, updated) => {
  const a = itemsToMap(original);
  const b = itemsToMap(updated);
  const names = new Set([...a.keys(), ...b.keys()]);
  const changes = [];
  names.forEach(name => {
    const oa = a.get(name);
    const ub = b.get(name);
    const oQty = oa?.quantity || 0;
    const uQty = ub?.quantity || 0;
    if (oQty !== uQty) {
      changes.push({ name, from: oQty, to: uQty, price: ub?.price || oa?.price || 0 });
    }
  });
  return changes;
};

export const calcItemsTotal = (items) => (items || []).reduce((s, i) => s + (Number(i.price) || 0) * (Number(i.quantity) || 0), 0);

// Input sanitization
export const sanitizeText = (value, maxLength = 500) => {
  if (typeof value !== 'string') return '';
  return value.replace(/<[^>]*>/g, '').slice(0, maxLength);
};

export const sanitizeNumeric = (value, { min = 0, max = 999999, fallback = '' } = {}) => {
  if (value === '' || value === undefined || value === null) return fallback;
  const num = Number(value);
  if (isNaN(num)) return fallback;
  if (num < min) return min;
  if (num > max) return max;
  return value;
};
